import styled from '@emotion/styled'

import { Spacing } from '../../../../enums/spacing'
import { Checkbox } from '../../../Checkbox'

export const TableCheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 40px;
  height: 100%;
  position: absolute;
  top: 0;
  left: ${Spacing.S2};
`

export const CheckboxWrapper = styled(Checkbox)`
  margin-left: ${Spacing.S8};
`
